<template>

    <div v-if="productsArray">

        <div v-if="productsArray.length > 0">

            <carousel v-if="productsArray.length > 0" @page-change="vue3DResized()" :perPage=1 :autoplay=true :loop=true :speed=1000 :paginationPadding=3 paginationActiveColor="rgba(255, 255, 255, 0.72)" paginationColor="rgba(255, 255, 255, 0.28)" :autoplayTimeout=4000 ease=true :adjustableHeight=true style="cursor: grab;">

                <slide v-for="(item, i) in productsArray" :key="i">

                    <img v-if="item.type == 'Image'" v-lazy="item.url" width="100%" height="auto" align="middle"/>

                    <video width="100%" v-else height="auto" controls playsinline autoplay muted loop>

                        <source :src="item.url" type="video/mp4">

                        <source :src="item.url" type="video/webm">

                        <source :src="item.url" type="video/ogg">

                    </video>

                </slide>

            </carousel>

        </div>

        <img v-else v-lazy="getImgUrl(defaultImageUrl)" width="100%" height="auto"/>

    </div>

</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
    data() {
        return {
            defaultImageUrl: 'placeholder'
        }
    },
    props: ["product"],
    computed: {
         productsArray() {

            let array = this.product;

            let temp = null;

            if( array.product_images ){

                temp = array.product_images.map((item) => {

                    let temp = item.url.split('.');

                    if(temp[temp.length-1].toLowerCase() === 'jpg' || temp[temp.length-1].toLowerCase() === 'png' || temp[temp.length-1].toLowerCase() === 'gif' || temp[temp.length-1].toLowerCase() === 'jpeg'){

                        item.type="Image";

                        return item;

                    }else if(temp[temp.length-1].toLowerCase() === 'mp4' || temp[temp.length-1].toLowerCase() === 'webm'|| temp[temp.length-1].toLowerCase() === 'ogg'){

                        item.type="Video";

                        return item;

                    }else{

                        item.type="Unkown";

                        return item;

                    }

                });

                temp = temp.filter(product => product.type != 'Unkown');
            }

            return temp;
        }
    },
    components: {
        Carousel,
        Slide
    },
    updated(){

        this.ImageLoaded();

    },
    methods: {
        getImgUrl(img) {

            var images = require.context('@/assets/', false, /\.png$/);

            return images('./' + img + ".png");

        },
        ImageLoaded(){

            this.$emit('ImageIsLoaded');

        },
        vue3DResized(){

             this.$emit('ImageIsLoaded');

        }
    }
}
</script>

